import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';

import Navbar from './components/navbar';
import { AuthProvider } from './context/AuthContext';
import ScrollToTop from './components/ScrollToTop';

// --- LENIWE ŁADOWANIE (LAZY LOADING) WIDOKÓW ---
// React rozbije te komponenty na osobne pliki .js i pobierze tylko te, które są aktualnie potrzebne
const App = lazy(() => import('./App'));
const PostPage = lazy(() => import('./pages/postPage'));
const UserPage = lazy(() => import('./pages/userPage'));
const WelcomePage = lazy(() => import('./pages/welcomePage'));
const CreatePostPage = lazy(() => import('./pages/createPostPage'));
const SavedPage = lazy(() => import('./pages/savedPage'));
const ProfilePage = lazy(() => import('./pages/profilePage'));

const Layout = () => {
  return (
    <>
      <Navbar />
      <div className="content-container pb-20 lg:pb-4 lg:pt-16">
        <Outlet />
      </div>
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <ScrollToTop />
      {/* Suspense odpowiada za wyświetlenie tymczasowego ekranu (fallback) 
        podczas gdy przeglądarka dociąga nową paczkę z kodem danej podstrony 
      */}
      <Suspense
        fallback={
          <div className="flex min-h-screen w-full items-center justify-center font-Outfit text-xl font-medium text-gray-400">
            {/* Tutaj możesz wstawić np. logo, spinner lub zostawić pusty ekran */}
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<WelcomePage />} />

          <Route element={<Layout />}>
            <Route path="/home" element={<App />} />
            <Route path="/create" element={<CreatePostPage />} />
            <Route path="/saved" element={<SavedPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/post/:id" element={<PostPage />} />
            <Route path="/user/:id" element={<UserPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  </AuthProvider>,
);

reportWebVitals();
